import React from "react";

const PriorityBadge = ({ priority }) => {
  return (
    <strong>
      {" "}
      {priority == "low" && <span className="badge rounded-pill low ">{"Low"}</span>}
      {priority == "medium" && <span className="badge rounded-pill medium ">{"Medium"}</span>}
      {priority === "high" && <span className="badge rounded-pill high">{"High"}</span>}
    </strong>
  );
};

export default PriorityBadge;
